module.exports = __webpack_public_path__ + "static/media/wijdezorg_logo.0a9f7374.jpeg";